import i18n from 'i18next';
import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({}) => {
  return {
    timeIntervals: {
      [SERVICE_PROVIDERS.RADIUS]: () => 1,
      [SERVICE_PROVIDERS.TTS]: () => 1,
      [SERVICE_PROVIDERS.NAUTO]: () => 1,
      [SERVICE_PROVIDERS.WEBFLEET]: () => 1,
      default: () => 5,
    },
    enableEditOWColumns_stateModifier: {
      [SERVICE_PROVIDERS.CLUTCH]: () => i18n.t('logs.oildFieldWaiting'),
      default: () => i18n.t('logs.stateModifier'),
    },
    checkServiceProvider_isOW_label: {
      [SERVICE_PROVIDERS.CLUTCH]: () => 'Yes',
      default: () => 'OIL_FIELD_WAITING',
    },
    stateModifier: {
      [SERVICE_PROVIDERS.CLUTCH]: () => true,
      default: () => false,
    },
    tableIcon: {
      [SERVICE_PROVIDERS.SPIREON]: () => true,
      default: () => false,
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
